import { render, staticRenderFns } from "./MentoriasCerradasListaItem.vue?vue&type=template&id=4011c180&"
import script from "./MentoriasCerradasListaItem.vue?vue&type=script&lang=js&"
export * from "./MentoriasCerradasListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports